import React from "react";

export default function Alert() {
  return <div className="alert-container"></div>;
}
